var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16641 7.59375C9 7.75781 8.78438 7.83984 8.56875 7.83984C8.35313 7.83984 8.1375 7.75781 7.97344 7.59141C7.64297 7.26328 7.64297 6.72891 7.97344 6.39844L11.4047 2.96953C11.7328 2.63906 12.2672 2.63906 12.5977 2.96953L16.0289 6.39844C16.3594 6.72656 16.3594 7.26094 16.0289 7.59141C15.8625 7.75547 15.6492 7.8375 15.4312 7.8375C15.2133 7.8375 14.9977 7.75547 14.8336 7.59141L12.8438 5.60156V16.125C12.8438 16.5914 12.4664 16.9688 12 16.9688C11.5336 16.9688 11.1562 16.5914 11.1562 16.125V5.60156L9.16641 7.59375ZM1.59375 20.4375C1.59375 19.9711 1.97109 19.5938 2.4375 19.5938H21.5625C22.0289 19.5938 22.4062 19.9711 22.4062 20.4375C22.4062 20.9039 22.0289 21.2812 21.5625 21.2812H2.4375C1.97109 21.2812 1.59375 20.9039 1.59375 20.4375Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.39579fedc94863cd1d225e0a543ea0be.svg";
export { ForwardRef as ReactComponent };